import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import PacingTab from "./tabs/pacing-tab";
import AnalysisTab from "./tabs/analysis-tab";
import OverviewTab from "./tabs/overview-tab";
import OverviewBetaTab from "./tabs/overview-beta-tab";
import { AppLayout } from "../../components/layout/app-layout";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUserClients, getUserStateActiveClient } from "src/redux/user/user.selectors";
import { StudioHandoffNotice } from "src/components/studio-handoff/studio-handoff-notice";

const PerformancePage = () => {
  useSetPageTitle('Performance');
  const navigate = useNavigate();
  const { clientId } = useParams<{ clientId?: string }>();
  const activeClient = useSelector(getUserStateActiveClient);
  const clients = useSelector(getUserClients);
  const handoffClient = activeClient ?? clients?.find((client) => client.ext_client_id === clientId) ?? null;

  const performanceTabs = [
    {
      id: '',
      key: 'ALL',
      label: 'Overview',
    },
    {
      id: 'overview-beta',
      key: 'overview-beta',
      label: 'Overview (Beta)',
    },
    {
      id: 'pacing',
      key: 'pacing',
      label: 'Pacing',
    },
    // {
    //   id: 'analysis',
    //   label: 'Analysis',
    // },
  ];

  const { tab } = useParams<{ tab?: string }>();

  const validTabs = performanceTabs.map(tab => tab.id);
  type TabType = typeof validTabs[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : '';

  const handleTabChange = (tabId: string) => {
    if (clientId) {
      navigate(`/client/${clientId}/performance/${tabId}`);
    } else {
      navigate(`/performance/${tabId}`);
    }
  };
  // New layout for org admins and regular users
  return (
    <AppLayout
      activePage="/performance"
      navbarProps={{
        showBackButton: false,
        backPath: "/performance",
        tabs: performanceTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >
      <div className="h-[calc(100vh-8rem)] space-y-4">
        <StudioHandoffNotice client={handoffClient} />
        {currentTab === '' && <OverviewTab />}
        {currentTab === 'overview-beta' && <OverviewBetaTab />}
        {currentTab === 'pacing' && <PacingTab />}
        {currentTab === 'analysis' && <AnalysisTab />}
      </div>
    </AppLayout>
  );
};

export default PerformancePage;